import React, { useState, useEffect } from "react";
import AppContainer from "./../../components/containers/AppContainer";
import { Box, Divider, Stack, Typography } from "@mui/material";
import TextInput from "../../components/textInput";
import { APP_ICONS } from "../../assets";
import DynamicTable from "../../components/dynamicTable";

const tableHeader = ["PAYMENT METHOD", "DATE", "AMOUNT", "STATUS"];

const displayRows = [
  "payment_data",
  "created_at",
  "withDrawn_amount",
  "withDrawn_status",
];

const WithDrawalsRequest = ({ walletsHistory }) => {
  const [filterText, setFilterText] = useState("");
  const [filteredData, setFilteredData] = useState(walletsHistory);

  useEffect(() => {
    // Update filtered data whenever filterText changes
    const filtered = walletsHistory.filter(
      (row) =>
        row?.vendorDetails?.name
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        row?.vendorDetails?.email
          .toLowerCase()
          .includes(filterText.toLowerCase())
    );

    setFilteredData(filtered);
  }, [filterText, walletsHistory]);

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  return (
    <AppContainer>
      <Stack
        px={2.5}
        py={2}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Stack>
          <Typography variant="h5" fontWeight={600}>
            Withdrawal History
          </Typography>
        </Stack>
      </Stack>
      <Divider sx={{ borderColor: "#BDBDBD" }} />
      <Stack px={2.5} py={2} direction={"row"} alignItems={"center"}>
        <Box>
          <TextInput
            sx={{ flex: 1 }}
            placeholder={"Search By details"}
            InputStartIcon={<img src={APP_ICONS.searhIcon} width={20} />}
            value={filterText}
            onChange={handleFilterChange}
          />
        </Box>
      </Stack>
      <Divider />
      {filteredData?.length > 0 ? (
        <DynamicTable
          tableHeader={tableHeader}
          displayRows={displayRows}
          tableData={filteredData}
          showPagination={true}
          showRequestMenu={true}
        />
      ) : (
        <Typography
          color="black"
          fontSize={14}
          fontWeight={700}
          textAlign="center"
          padding="30px 0"
        >
          No Withdrawal History Found!
        </Typography>
      )}
    </AppContainer>
  );
};

export default WithDrawalsRequest;
